import { Helmet } from "react-helmet-async";
import { WebPageJsonLd } from "@/components/seo/WebPageJsonLd";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const Careers = () => (
  <>
    <Helmet>
      <title>Careers | Elara Health</title>
      <meta name="description" content="Join Elara Health and help build the future of clinician-guided metabolic and longevity care." />
      <link rel="canonical" href="https://elarahealth.life/careers" />
      <meta property="og:title" content="Careers | Elara Health" />
      <meta property="og:url" content="https://elarahealth.life/careers" />
    </Helmet>
    <WebPageJsonLd
      path="/careers"
      name={"Careers at Elara Health"}
      description={"Join Elara Health and help build the future of clinician-guided metabolic and longevity care."}
    />
    <Navbar />
    <main className="min-h-screen pt-24 pb-16">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="font-display text-4xl md:text-5xl text-foreground mb-6">Careers</h1>
        <div className="prose prose-lg text-muted-foreground space-y-4">
          <p>
            We're building the future of personalized metabolic care. If you're passionate about
            healthcare innovation, we'd love to hear from you.
          </p>
          <p>
            There are no open positions at this time. Check back soon or reach out to us at{" "}
            <a href="mailto:careers@elarahealth.life" className="text-champagne hover:underline">
              careers@elarahealth.life
            </a>.
          </p>
        </div>
      </div>
    </main>
    <Footer />
  </>
);

export default Careers;
